// extracted by mini-css-extract-plugin
module.exports = {"title_container":"title_container--2ebT6","foot_container":"foot_container--105ES"};